<life-di-nav></life-di-nav>
<lifedi-breadcrumb></lifedi-breadcrumb>

<div class="container">
  <div class="row justify-content-center">
    <h1 class="lifedi-color">
      ระบบกิจกรรม
    </h1>
  </div>
  <div class="row mt-5">
    <div class="col-md-6 col-12">
      <div class="selectTopic text-center" routerLink="consult">
        <img src="../../../assets/consulting.png" class="topicImg">
      </div>
      <p class="textTopic text-center">
        <span class="top">บริการให้คำแนะนำ/ปรึกษา</span><br>
        <span class="top">ปัญหาพัฒนาการทุกช่วงวัย</span>
        <br>
        <span class="second">
          Consult & Intervention
        </span>
      </p>
    </div>
    <div class="col-md-6 col-12">
      <div class="selectTopic text-center" routerLink="workshop">
        <img src="../../../assets/workshop.png" class="topicImg">
      </div>
      <p class="textTopic text-center">
        <span class="top">คอร์สอบรมและกิจกรรม</span>
        <br>
        <span class="second">
          Training & Workshop
        </span>
      </p>
    </div>
  </div>
</div>